import React from 'react';
import { Statistic } from 'antd';
import type { CountdownProps } from 'antd/es/statistic/Countdown';
import type { BaseComponentProps } from '../../types/common';



export interface AndStatisticsCountdownProps extends CountdownProps, BaseComponentProps {}

export const AndStatisticsCountdown: React.FC<AndStatisticsCountdownProps> = ({
  id, sessionId, develop, ...restProps
}) => {
  // @ts-ignore
  const Timer = Statistic.Timer;
  if (Timer) {
    return <Timer type="countdown" {...restProps} />;
  }
  const { Countdown } = Statistic;
  return <Countdown {...restProps} />;
};

export default AndStatisticsCountdown;
